import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoadingService } from '../../../shared/services/loading.service';
import { UserService } from '../../../shared/services/user.service';
import { CreateNewTemperatureInspectionComponent } from '../../Temperature/create-new-temperature-inspection/create-new-temperature-inspection.component';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '../../../../app/translate';
import { TemperatureInspectionService } from '../../Temperature/temperature-inspection.service';
import { Router } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { ThermographyLinkPinVM, ThermographynspectionVM } from '../thermography-inspection.model';
import { ThermographyInspectionService } from '../thermography-inspection.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-create-dialog-thermography',
  templateUrl: './create-dialog-thermography.component.html',
  styleUrls: ['./create-dialog-thermography.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class CreateDialogThermographyComponent implements OnInit {
  
  public todate = new Date();
  isInspector:boolean=false;
  dateReplaced: Date = new Date();
  translateSubscription:Subscription;
  userLanguage = 'english';
  EquipmentSetupDate:string;
  selectedSMU:number;
  equipmentId:number;
  SMUValidate:boolean;

  model:string;
  selectedSide:number;


EnableStartInspection:boolean=false;
pinCount:number;
hasEquipment:boolean=true;

isloading = true;
isValid:boolean=true;
DoneInspection:boolean=false;
constructor(private _loading: LoadingService,
  private _userService: UserService,
  public dialogRef: MatDialogRef<CreateDialogThermographyComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any,
  private _manageService: ManageEquipmentService,
  private _notification: NotificationsService,
  private _translate: TranslateService,private ref: ChangeDetectorRef, 
  private  _thermographyService: ThermographyInspectionService,
  private _router: Router,private _appService: AppService,
) { }

  ngOnInit() {
    this.loadUserJobRoles();
    this.CheckAddNewIspectionMenuAccess();
    this.EquipmentSetupDate= this.data.eqSetupDate;
    this.equipmentId=this.data.equipmentId;
    this.model= this.data.model;
    console.log("Date", this.data)
     
    
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }
  onNoClick() {
    this.dialogRef.close();
  }
  CheckAddNewIspectionMenuAccess(){
    this._userService.CheckAddNewIspectionMenuAccess().subscribe(res=>{
      if(res==true){
        this.isInspector = true;
      }else{
        this.isInspector = false;
      }
    })
  }
  loadUserJobRoles() {
    this._loading.startLoading();
    this._userService.getUserJobRoles().subscribe(roles => {
        roles.forEach(r => {
            switch (r.Name) {
                case 'Inspectors':
                    this.isInspector = true;
                    break;
                case 'Interpreters':
                    this.isInspector = true;
                    break;
                case 'Super User':
                case 'Administrator':
                    this.isInspector = true;
                    break;
                    case 'Customer Admin':
                      this.isInspector = true;
                      break;
            }
        });

        this._loading.finishedLoading();
    });
  }

  InspectionDate:string;
  CreateInspection(){

    
    var temp = new ThermographynspectionVM()
    {
      temp.InspectionDate =this.dateReplaced; //this.dateReplaced.toLocaleString();
      temp.EquipmentId =this.equipmentId;
      temp.SMU=this.selectedSMU;
    }
    this._thermographyService.ValidateSMUAndDate(temp).subscribe(result=>{
      if (result.m_Item1) {
        console.log("result11111 Righ", result)
        this.SMUValidate=true;
        this.InspectionDate=this.getFormatedDate(new Date(this.dateReplaced));
        //Need to redirect to Interp page
        this._thermographyService.CreateThermogarphyInspection(this.equipmentId,this.selectedSMU, this.InspectionDate).subscribe(result=>{
          console.log("result", result)
          if (result > 0) {
           let inspectionId = result;
            this._notification.success('Success',"Successfully Created a Thermography Inspection" );
            this.dialogRef.close(true);
            this._router.navigate(['thermography-inspection', this.equipmentId , inspectionId]);
          }
          else {
            this._notification.error('Failed', "Failed to Create a Thermography Inspection");
            this.dialogRef.disableClose=true;
          }
          }, error => console.error(error), () => {  });
       }
       else {
         this.SMUValidate=false;
         this._notification.error('Failed', result.m_Item2);
         this.dialogRef.disableClose=true;
       }
    }) 
    }


    getFormatedDate = (currentDate) => {
  
      console.log("curernt ", currentDate)
      let dd = currentDate.getDate();
      let mm = currentDate.getMonth() + 1; // January is 0!
      const yyyy = currentDate.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }
      if (mm < 10) {
        mm = `0${mm}`;
      }
      return `${dd} ${mm} ${yyyy}`;
    };

}
